import React from 'react'
// import classNames from 'classnames'
// import Button from '@material-ui/core/Button';
// import { Link } from 'gatsby' USE WITH V2
import Link from 'gatsby-link'
import { withPrefix } from 'gatsby-link'

import withRoot from '../withRoot'

// import InfoIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';



import css from './footer.module.css'
// import SimpleMenu from './menu'

import 'typeface-roboto'



const Footer = ({ siteTitle }) => (

  // <div>test</div>
  
  <div className={css.footerOuter}>
    <div className={css.footerContainer}>
      <div className={css.leftFooterContainer}>
        <div style={{msGridColumn: 1}}></div>
        <div className={css.listContainer} style={{msGridColumn: 2}}>
          <div><h3>Company</h3></div>
          <div className={css.textList}><Link to="/" >Home</Link></div>
          <div className={css.textList}><Link to="/about" >About</Link></div>
          <div className={css.textList}><Link to="/contact" >Contact</Link></div>
          {/* <div className={css.textList}><Link to="/terms" >Terms</Link></div> */}
          <div className={css.textList}><Link to="/privacy" >Privacy</Link></div>
        
        </div>
        <div style={{msGridColumn: 3}}></div>
        <div className={css.listContainer} style={{msGridColumn: 4}}>
          <div><h3>Products</h3></div>
          <div className={css.textList}><Link to="/perennials" >Perennials</Link></div>
          <div className={css.textList}><Link to="/trees" >Trees &amp; Shrubs</Link></div>
          <div className={css.textList}><Link to="/wetland" >Wetland</Link></div>
          <div className={css.textList}><Link to="/ferns" >Ferns</Link></div>
          <div className={css.textList}><a href={withPrefix("../files/Trillium_Catalog.pdf")} download="Trillium_Catalog.pdf">Download Catalog</a></div>
          
          {/* <Link to={Catalog} >Download Catalog</Link></div> */}
        </div>
        <div style={{msGridColumn: 5}}></div>
      </div>

      <div className={css.rightFooterContainer}>
        <div style={{msGridColumn: 1}}></div>
        <div className={css.listContainer} style={{msGridColumn: 2}}>
          <div><h3>Community</h3></div>
          <div className={css.textList}><a href="https://twitter.com/TrilliumGardens" >Twitter</a></div>
          <div className={css.textList}><a href="https://www.facebook.com/" >Facebook</a></div>
          <div className={css.textList}><a href="https://www.instagram.com/trilliumgardens/" >Instagram</a></div>
        </div>
        <div style={{msGridColumn: 3}}></div>
        <div className={css.listContainer} style={{msGridColumn: 4}}>
          <div><h3>Resources</h3></div>
          {/* <div className={css.textList}><a href="http://www.oregonflora.org/index.php" >Oregon Flora Project</a>
            <div className={css.info}>
              <Tooltip title=" The Oregon Flora Project website contains an Oregon plant atlas, photo gallery, rare plant guide, vascular plant checklist, and a native gardening guide. Volume 1 of the Flora of Oregon was published in 2015, and Volumes 2 and 3 are in the works.">
                  <InfoIcon />
              </Tooltip>
            </div>
          </div> */}
          
          <div className={css.textList}>
            
            <Tooltip title="The Oregon Flora Project website contains an Oregon plant atlas, photo gallery, rare plant guide, vascular plant checklist, and a native gardening guide. Volume 1 of the Flora of Oregon was published in 2015, and Volumes 2 and 3 are in the works.">
              {/* <div className={css.info}><InfoIcon /></div> */}
              <a href="http://www.oregonflora.org/index.php" >Oregon Flora Project </a>
            </Tooltip>
            
          </div>

          <div className={css.textList}>
            
            <Tooltip title="An eco-region is a geographic area that helps define the soils, climate, geology, vegetation, physiography, and hydrology the parent plant came from. This is helpful in choosing suitable seed sources.">
              <a href="ftp://newftp.epa.gov/EPADataCommons/ORD/Ecoregions/or/or_eco_pg.pdf" >Eco-regions of Oregon (pdf) </a>
              {/* <div className={css.info}><InfoIcon /></div> */}
            </Tooltip>
            
          </div>

          <div className={css.textList}>
            
            <Tooltip title="An eco-region is a geographic area that helps define the soils, climate, geology, vegetation, physiography, and hydrology the parent plant came from. This is helpful in choosing suitable seed sources.">
              {/* <div className={css.info}><InfoIcon /></div> */}
              <a href="ftp://newftp.epa.gov/EPADataCommons/ORD/Ecoregions/wa/wa_eco.pdf" >Eco-regions of Washington (pdf) </a>
            </Tooltip>
            
          </div>

          <div className={css.textList}>
            
            <Tooltip disableFocusListener title="To find out the distribution, wetland indicator, and general information; search for the plant you want information about on the USDA PLANTS website.">
              {/* <div className={css.info}><InfoIcon /></div> */}
              <a href="https://plants.sc.egov.usda.gov/core/profile?symbol=ACCI" >USDA plants </a>
            </Tooltip>
           
          </div>

          <div className={css.textList}>
            
            <Tooltip disableFocusListener title="The Washington Native Plant Society has a great website with information on using native plants gardens and restoration projects.">
              {/* <div className={css.info}><InfoIcon /></div> */}
              <a href="https://www.wnps.org/landscaping/herbarium/index.html" >WNPS plant list </a>
            </Tooltip>
            
          </div>    
          

          {/* <Tooltip title="An eco-region is a geographic area that helps define the soils, climate, geology, vegetation, physiography, and hydrology the parent plant came from. This is helpful in choosing suitable seed sources.">
            <div className={css.textList}><a href="ftp://newftp.epa.gov/EPADataCommons/ORD/Ecoregions/or/or_eco_pg.pdf" >Eco-regions of Oregon (pdf)</a></div>
          </Tooltip>            

          <Tooltip title="An eco-region is a geographic area that helps define the soils, climate, geology, vegetation, physiography, and hydrology the parent plant came from. This is helpful in choosing suitable seed sources.">
            <div className={css.textList}><a href="ftp://newftp.epa.gov/EPADataCommons/ORD/Ecoregions/wa/wa_eco.pdf" >Eco-regions of Washington (pdf)</a></div>
          </Tooltip>

          <Tooltip title="To find out the distribution, wetland indicator, and general information; search for the plant you want information about on the USDA PLANTS website.">
          <div className={css.textList}><a href="https://plants.sc.egov.usda.gov/core/profile?symbol=ACCI" >USDA plants</a></div>
          </Tooltip>

          <Tooltip title="The Washington Native Plant Society has a great website with information on using native plants gardens and restoration projects.">
            <div className={css.textList}><a href="https://www.wnps.org/landscaping/herbarium/index.html" >WNPS plant list</a></div>
          </Tooltip> */}

        </div>
        <div style={{msGridColumn: 5}}></div>
      </div>    
    </div>

    <div className={css.copyright}>&copy; 2018 Trillium Gardens LLC </div>
  </div>

  
)

export default withRoot(Footer)



// WEBPACK FOOTER //
// ./src/components/footer.js